import {IRule} from './rule.interface';
import {IPredicate} from './predicate.interface';

export class RuleModel implements IRule {
  id: number;
  name: string;
  description: string;
  inputChannel: any;
  predicate: IPredicate;
  actions: any;
  constructor() {
    this.inputChannel = {};
    this.predicate = {
      conditions: [],
      infix: null
    };
    this.actions = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/model/RuleModel.ts